import { useEffect } from 'react';
import { db } from '../firebase';
import { onSnapshot, collection, query, where, limit } from 'firebase/firestore';
import useAuthStore from '../stores/authStore';
import useSubscriptionStore from '../stores/subscriptionStore';
import useProductStore from '../stores/productStore';

const useSubscriptionListener = () => {
    const { user } = useAuthStore();
    const {
        setSubscription,
        setIsLoading,
        setIsDemo,
        setIsEssential,
        setIsUltimate,
    } = useSubscriptionStore();
    const { products, setCurrentProduct, isLoading: isProductLoading } = useProductStore();

    useEffect(() => {
        if (!user || !user.emailVerified || isProductLoading) {
            return;
        }

        const subscriptionsRef = collection(db, 'users', user.uid, 'subscriptions');
        const q = query(subscriptionsRef, where('status', 'in', ['active', 'trialing']), limit(1));

        const unsubscribe = onSnapshot(q, (snapshot) => {
            if (!snapshot.empty) {
                const doc = snapshot.docs[0];
                const subData = {
                    id: doc.id,
                    ...doc.data()
                };
                setSubscription(subData);
                setIsDemo(false);

                const currentProduct = products.find(p => p.id === subData.productId);
                if (currentProduct) {
                    setCurrentProduct(currentProduct);
                    setIsEssential(currentProduct.name.toLowerCase() === 'essential');
                    setIsUltimate(currentProduct.name.toLowerCase() === 'ultimate');
                }
            } else {
                setSubscription(null);
                setIsEssential(false);
                setIsDemo(true);
                setCurrentProduct(null);
            }
            setIsLoading(false);
        });

        return () => unsubscribe();
    }, [
        user,
        setIsDemo,
        setIsEssential,
        setIsLoading,
        setSubscription,
        products,
        setCurrentProduct,
        setIsUltimate,
        isProductLoading
    ]);
};

export default useSubscriptionListener;